
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-hooks-use-dnd-demo-xflow-hooks-use-dnd"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.zh.md?type=demo')
};